module.exports = __webpack_public_path__ + "static/media/energy.16a35705.png";